import { API_PARAM_IS_REDESIGN_CONTEXT } from '../../constants/api'
import { getApi, getId2IdEndpoint, patchApi, postApi } from '../../utils/api'

function unsupportedReorder(operationName) {
  return Promise.reject(
    new Error(
      `${operationName} is not supported because no backend reorder endpoint is configured yet.`
    )
  )
}

export function getPipelinePhase({ outboundUuid, phaseId }) {
  return getApi({
    endpoint: getId2IdEndpoint({
      outboundUuid,
      path: `pipeline/phase/${phaseId}/`,
    }),
  })
}

export function getPipelinePhaseActivities({ outboundUuid, params, phaseId }) {
  return getApi({
    endpoint: getId2IdEndpoint({
      outboundUuid,
      path: `pipeline/phase/${phaseId}/activity/`,
    }),
    params: {
      ...params,
      [API_PARAM_IS_REDESIGN_CONTEXT]: true,
    },
  })
}

export function getPipelinePhaseFiles({ outboundUuid, params, phaseId }) {
  return getApi({
    endpoint: getId2IdEndpoint({
      outboundUuid,
      path: `pipeline/phase/${phaseId}/files/`,
    }),
    params: {
      ...params,
      [API_PARAM_IS_REDESIGN_CONTEXT]: true,
    },
  })
}

export function togglePipelinePhaseVisibilityToTenant(phaseId) {
  return postApi({
    endpoint: `api/pipeline/phase/${phaseId}/toggle-is-visible-to-tenant/`,
  })
}

export function populatePipelinePhase(phaseId) {
  return postApi({
    endpoint: `api/pipeline/phase/${phaseId}/populate/`,
  })
}

export function createPipelinePhase(data) {
  return postApi({
    data,
    endpoint: 'api/pipeline/phase/',
  })
}

export function getPipelineActivity(activityId) {
  return getApi({ endpoint: `api/pipeline/activity/${activityId}/` })
}

export function updatePipelineActivity(activityId, data) {
  return patchApi({
    data,
    endpoint: `api/pipeline/activity/${activityId}/`,
  })
}

// TODO: replace with real API endpoint when available
export function reorderPhases() {
  return unsupportedReorder('reorderPhases')
}
